import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { analySend, getInfo } from '@chat/utils';
import { IM_CTX, IM_MESSAGE } from '@/typings/global';
import { GM_AVATAR, GM_NICK } from '@/helpers/userInfo';
import MsgActions from '@/components/MessageList/MsgActions';

function index(props: IM_MESSAGE): JSX.Element {
    const { message, ctx, id } = props;
    // start控制是否展示人工按钮
    const { start = 0 } = ctx as IM_CTX;
    const { u, v } = getInfo();
    const { can_faq, disabled_stage, platform, game_key, game_name, faq_unique_id, request_type } =
        useSelector(
            ({ FaqReducer, IndexReducer }) => ({
                can_faq: FaqReducer.can_faq,
                disabled_stage: FaqReducer.disabled_stage,
                request_type: FaqReducer.request_type,
                platform: IndexReducer.base_config.game.platform,
                game_key: IndexReducer.base_config.game.key,
                game_name: IndexReducer.base_config.game.name,
                faq_unique_id: IndexReducer.base_config.faq_unique_id
            }),
            shallowEqual
        );
    const handleArt = () => {
        if (IM.InitServer.stageTurn()) {
            analySend('element_click', {
                page_name: '咨询页',
                element_name: '人工客服',
                project_id: platform,
                game_key,
                game_name,
                uid: u,
                vid: v,
                ai_session_id: faq_unique_id,
                ai_message_id: id,
                session_type: request_type,
                answer_source: (ctx as IM_CTX).dify === 1 ? 'AI' : '关键词匹配'
            });
        }
    };
    return (
        <li className="im-message-in">
            <div className="im-message-userinfo">{GM_AVATAR('faq', 'faq')}</div>
            <div className="im-message-block">
                {GM_NICK('faq', 'faq')}
                <div className="im-message-content">
                    {(ctx as IM_CTX).dify === 1 && message ? (
                        <div dangerouslySetInnerHTML={{ __html: message as string }} />
                    ) : (
                        <span>{message}</span>
                    )}
                    {start !== 0 && (
                        <div
                            className={classnames('im-art', {
                                'disable-art': disabled_stage || !can_faq
                            })}
                        >
                            <button
                                className={classnames('im-art-btn', {
                                    'disable-art-btn': disabled_stage || !can_faq
                                })}
                                onClick={handleArt}
                            >
                                <i className="icon-art" />
                                <span>人工客服</span>
                            </button>
                        </div>
                    )}
                </div>
                <MsgActions item={props} />
            </div>
        </li>
    );
}

export default index;
